"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fromDirection = exports.fadeIn = exports.dissolve = exports.bounceFromTop = void 0;
exports.hoverTransition = hoverTransition;
exports.twinkle = exports.transitionProperties = exports.transition = exports.spin = exports.skBounceDelay = exports.shine = void 0;
var _styledComponents = require("styled-components");
var translateProp = {
  up: 'translateY(-100%)',
  down: 'translateY(100%)',
  left: 'translateX(-100%)',
  right: 'translateX(100%)'
};
var fromDirection = exports.fromDirection = function fromDirection() {
  var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'right';
  return (0, _styledComponents.keyframes)(["from{transform:", ";}to{transform:translate(0,0);}"], translateProp[direction]);
};
var fadeIn = exports.fadeIn = function fadeIn() {
  return (0, _styledComponents.keyframes)(["from{opacity:0;}to{opacity:1;}"]);
};
var dissolve = exports.dissolve = function dissolve() {
  var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'up';
  return (0, _styledComponents.keyframes)(["from{transform:translate(0,0);opacity:1;}to{transform:", ";opacity:0;}"], translateProp[direction]);
};
var spin = exports.spin = (0, _styledComponents.keyframes)(["from{transform:rotate(0deg);}to{transform:rotate(360deg);}"]);
var skBounceDelay = exports.skBounceDelay = (0, _styledComponents.keyframes)(["0%,80%,100%{transform:scale(0);opacity:0}40%{transform:scale(1);opacity:1}"]);
var transition = exports.transition = function transition() {
  var property = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'all';
  var durationEffect = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '0.15s';
  var timingFunction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'ease-in';
  return (0, _styledComponents.css)(["transition:", " ", " ", ";"], property, durationEffect, timingFunction);
};

// pass specific properties to overwrite transition all
var transitionProperties = exports.transitionProperties = function transitionProperties(properties) {
  return (0, _styledComponents.css)(["transition-property:", ";"], properties);
};
function hoverTransition(property, currVal, hoverVal, durationEffect, timingFunction) {
  var includeFocus = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
  return (0, _styledComponents.css)(["", " ", " &:hover,&:focus-visible{", "}", ""], "".concat(property, ": ").concat(currVal, ";"), transition(property, durationEffect, timingFunction), "".concat(property, ": ").concat(hoverVal, ";"), includeFocus && (0, _styledComponents.css)(["&:focus{", "}"], "".concat(property, ": ").concat(hoverVal, ";")));
}
var twinkle = exports.twinkle = (0, _styledComponents.keyframes)(["50%{transform:scale(0.5);opacity:0.5;}"]);
var shine = exports.shine = (0, _styledComponents.keyframes)(["to{background-position-x:-200%;}"]);
var bounceFromTop = exports.bounceFromTop = (0, _styledComponents.keyframes)(["    0%{transform:", ";}65%{transform:translateY(-56px);animation-timing-function:ease-in;}82%{transform:translateY(-32px);animation-timing-function:ease-in;}93%{transform:translateY(-12px);animation-timing-function:ease-in;}55%,75%,87%,100%{transform:translateY(0px);animation-timing-function:ease-out;}"], translateProp.up);
//# sourceMappingURL=animations.js.map